var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIres3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 26,
    r: 15,
    style: {
      fill: "#FFCB57"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61,31.184v-8.369c1.161-0.414,2-1.514,2-2.816c0-1.654-1.346-3-3-3c-0.344,0-0.67,0.07-0.978,0.177   l-4.481-5.602C54.827,11.117,55,10.58,55,10c0-1.654-1.346-3-3-3c-0.841,0-1.599,0.35-2.145,0.909l-7.883-3.638   C41.981,4.18,42,4.093,42,4c0-1.654-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2H24.816C24.402,1.839,23.302,1,22,1   c-1.654,0-3,1.346-3,3c0,0.124,0.022,0.243,0.037,0.363l-4.96,2.48C13.537,6.324,12.807,6,12,6c-1.654,0-3,1.346-3,3   c0,0.58,0.173,1.117,0.458,1.576l-4.481,5.601C4.669,16.07,4.344,16,4,16c-1.654,0-3,1.346-3,3c0,1.302,0.839,2.402,2,2.816v6.369   C1.839,28.598,1,29.698,1,31c0,1.654,1.346,3,3,3c1.111,0,2.071-0.614,2.59-1.513l5.459,0.993C12.28,34.905,13.51,36,15,36   c0.041,0,0.078-0.01,0.118-0.012l1.908,4.77C16.402,41.309,16,42.104,16,43c0,1.654,1.346,3,3,3c1.006,0,1.893-0.502,2.437-1.264   l8.582,2.452c0.077,1.218,0.877,2.234,1.981,2.628v7.369c-1.161,0.414-2,1.514-2,2.816c0,1.654,1.346,3,3,3s3-1.346,3-3   c0-1.302-0.839-2.402-2-2.816v-7.369c1.161-0.414,2-1.514,2-2.816c0-0.958-0.46-1.804-1.162-2.353l1.194-3.582l8.973,2.991   c0.024,1.277,0.85,2.351,1.994,2.759v10.369c-1.161,0.414-2,1.514-2,2.816c0,1.654,1.346,3,3,3s3-1.346,3-3   c0-1.302-0.839-2.402-2-2.816V46.816c1.161-0.414,2-1.514,2-2.816c0-0.365-0.075-0.711-0.195-1.035l7.673-6.394   C58.925,36.837,59.442,37,60,37c1.654,0,3-1.346,3-3C63,32.698,62.161,31.598,61,31.184z M17.994,32.944   c-0.002-0.12-0.02-0.235-0.036-0.351l8.203-4.253l2.537,8.173L17.994,32.944z M15.762,30.11l-1.386-10.628l6.853-0.343   c0.435,1.054,1.454,1.8,2.652,1.848l1.679,5.411l-8.517,4.416C16.685,30.481,16.248,30.239,15.762,30.11z M6.772,17.86   c-0.063-0.153-0.144-0.297-0.231-0.436l4.481-5.601c0.116,0.04,0.23,0.083,0.351,0.109l0.739,5.661L6.772,17.86z M13.355,11.662   C14.327,11.165,15,10.164,15,9c0-0.124-0.022-0.243-0.037-0.363l4.96-2.48C20.463,6.676,21.193,7,22,7   c0.614,0,1.185-0.187,1.661-0.505l6.21,4.657l-4.496,4.196C24.961,15.134,24.498,15,24,15c-1.354,0-2.488,0.907-2.86,2.142   l-7.024,0.351L13.355,11.662z M36.253,5.197l-4.897,4.57L24.999,5h11.185C36.208,5.066,36.225,5.133,36.253,5.197z M39.041,19.408   l-8.047,4.173l-4.295-4.295C26.886,18.894,27,18.462,27,18c0-0.426-0.092-0.829-0.252-1.196l4.748-4.432l7.653,5.74   C39.061,18.394,39,18.689,39,19C39,19.14,39.023,19.273,39.041,19.408z M25,18c0,0.551-0.448,1-1,1s-1-0.449-1-1s0.448-1,1-1   S25,17.449,25,18z M29.132,24.546l-1.769,0.917l-1.209-3.895L29.132,24.546z M27.965,27.404l2.65-1.374l4.685,4.685   C35.114,31.106,35,31.538,35,32c0,0.959,0.46,1.804,1.162,2.353l-1.394,4.182l-3.734-1.245L27.965,27.404z M38,33   c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1S38.552,33,38,33z M38,29c-0.462,0-0.894,0.113-1.285,0.301l-4.237-4.237l7.48-3.879   C40.494,21.687,41.209,22,42,22c0.558,0,1.075-0.163,1.523-0.43l4.553,3.794l-8.083,4.409C39.461,29.298,38.768,29,38,29z    M50.578,12.625C51.003,12.857,51.483,13,52,13c0.344,0,0.669-0.07,0.977-0.177l4.481,5.602C57.173,18.884,57,19.42,57,20   c0,0.161,0.023,0.317,0.048,0.471l-7.083,3.864l-5.16-4.3C44.925,19.711,45,19.365,45,19c0-0.407-0.083-0.794-0.23-1.148   L50.578,12.625z M58.478,31.429l-6.861-5.718l6.391-3.486c0.287,0.258,0.622,0.458,0.993,0.59v8.369   C58.817,31.25,58.643,31.331,58.478,31.429z M43,19c0,0.551-0.448,1-1,1s-1-0.449-1-1s0.448-1,1-1S43,18.449,43,19z M49.728,26.742   l7.166,5.972l-15.526-1.412L49.728,26.742z M61,20c0,0.551-0.448,1-1,1s-1-0.449-1-1s0.448-1,1-1S61,19.449,61,20z M52,9   c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S51.448,9,52,9z M49.027,9.729C49.019,9.82,49,9.907,49,10   c0,0.407,0.083,0.794,0.23,1.148l-5.809,5.227C42.997,16.143,42.517,16,42,16c-0.614,0-1.185,0.187-1.661,0.505l-7.358-5.519   l4.645-4.335C38.039,6.867,38.502,7,39,7c0.841,0,1.6-0.35,2.145-0.909L49.027,9.729z M39,3c0.552,0,1,0.449,1,1s-0.448,1-1,1   s-1-0.449-1-1S38.448,3,39,3z M22,3c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S21.448,3,22,3z M12,8c0.552,0,1,0.449,1,1   s-0.448,1-1,1s-1-0.449-1-1S11.448,8,12,8z M4,18c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S3.448,18,4,18z M4,32   c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1S4.552,32,4,32z M5,28.184v-6.369c0.894-0.319,1.585-1.044,1.86-1.958l5.512-0.276   l1.394,10.69c-0.574,0.26-1.043,0.698-1.356,1.24L6.952,30.52C6.775,29.432,6.015,28.546,5,28.184z M14,33c0-0.551,0.448-1,1-1   s1,0.449,1,1s-0.448,1-1,1S14,33.551,14,33z M16.974,35.241c0.139-0.122,0.265-0.257,0.379-0.403l12.075,4.025l1.783,5.743   c-0.248,0.186-0.468,0.405-0.648,0.657l-8.582-2.452C21.882,41.247,20.59,40,19,40c-0.04,0-0.078,0.01-0.117,0.012L16.974,35.241z    M19,44c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1S19.552,44,19,44z M33,61c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1   S33.552,61,33,61z M33,48c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1S33.552,48,33,48z M33.034,43.736l-1.271-4.094l2.372,0.791   L33.034,43.736z M38.056,34.994c1.182-0.022,2.194-0.73,2.662-1.743l16.386,1.49c0.026,0.1,0.056,0.198,0.091,0.294l-7.673,6.394   C49.074,41.163,48.558,41,48,41c-0.958,0-1.804,0.46-2.353,1.162l-8.982-2.994L38.056,34.994z M48,61c-0.552,0-1-0.449-1-1   s0.448-1,1-1s1,0.449,1,1S48.552,61,48,61z M48,45c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1S48.552,45,48,45z M60,35   c-0.552,0-1-0.449-1-1s0.448-1,1-1s1,0.449,1,1S60.552,35,60,35z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 3,
    y: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 3,
    y: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 5,
    y: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 1,
    y: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 53,
    y: 47
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 53,
    y: 51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 55,
    y: 49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 51,
    y: 49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 59,
    y: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 59,
    y: 9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 61,
    y: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 57,
    y: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 13,
    y: 49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 13,
    y: 53
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 15,
    y: 51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 11,
    y: 51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 7,
    y: 38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 7,
    y: 42
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 9,
    y: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 5,
    y: 40
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIres3);
export default __webpack_public_path__ + "static/media/AIres3.2e0f93a6ec2966c068efb6e31313c8e0.svg";
export { ForwardRef as ReactComponent };